




































import { defineComponent, computed } from '@vue/composition-api';
import { useStore } from '@/store';
import ComparisonRow from '@/components/Comparison/ComparisonRow.vue';
import PriceComponent from '@/components/UI/Price.vue';
import ApproxPrice from '@/components/UI/ApproxPrice.vue';

export default defineComponent({
    name: 'VehiclePriceRow',
    components: { ApproxPrice, ComparisonRow, PriceComponent },
    setup () {
        const store = useStore();
        const prices = computed(
            () => store.state.tickedItems
                .map((id) => store.state.comparisonCache[id]?.Main?.Price)
        );
        const tradePrice = computed(
            () => store.state.tickedItems
                .map((id) => store.state.comparisonCache[id]?.Main?.TradePrice)
        );
        const additionalPrices = computed(
            () => store.state.tickedItems
                .map((id) => {
                    const additionalPrices = store.state.comparisonCache[id]?.Main?.AdditionalPrices;
                    return Array.isArray(additionalPrices) ? additionalPrices[0] : undefined;
                })
        );
        return { prices, tradePrice, additionalPrices };
    }
});
